import Task from 'models/tasks/task';
import { TaskDetailViewMode } from 'models/userSetting';

// The redesigned dialog is on when the user did not pick the classic layout; a new task and the
// mobile view always keep the classic layout
export const isNewTaskDetailView = (viewMode: TaskDetailViewMode, isMobileView: boolean, taskId: number): boolean =>
  viewMode !== 'classic' && !isMobileView && taskId !== -1;

export interface ITaskPivotTabsOptions {
  isNewView: boolean;
  //the classic layout shows Details as a tab only in the compact view
  compactView?: boolean;
  //a master task is open for this task
  hasMasterTask?: boolean;
  disallowSave?: boolean;
  hasFormFeature?: boolean;
  //an event: no Instances tab, and in the new view only a series has the form or the checklist as a tab
  isEvent?: boolean;
}

export interface ITaskPivotTabs {
  //the task has a form (task type) and the form feature is on
  hasForm: boolean;
  taskDetails: boolean;
  taskType: boolean;
  checklist: boolean;
  context: boolean;
  resources: boolean;
  activities: boolean;
  instances: boolean;
  audit: boolean;
}

// Which tabs a task shows. In the new view the checklist and the form are the main column, so the
// tabs are those of the right panel only.
export const getTaskPivotTabs = (task: Task, options: ITaskPivotTabsOptions): ITaskPivotTabs => {
  const hasForm = Boolean(options.hasFormFeature && task.taskTypeId && task.taskTypeId > 0);

  const isEventSeries = Boolean(options.isEvent && task.isSeries());

  return {
    hasForm,
    taskDetails: options.isNewView || options.compactView === true,
    taskType: hasForm && (!options.isNewView || isEventSeries),
    checklist: !hasForm && (!options.isNewView || isEventSeries),
    context: true,
    resources: true,
    activities: task.commentTrailId > 0 || (task.taskId === -1 && !options.disallowSave),
    instances:
      !options.isEvent && Boolean(task.isSeries() || options.hasMasterTask || (task.isInstance() && task.taskMasterId)),
    audit: task.auditTrailId > 0,
  };
};

// The keys of the shown tabs
export const getShownTaskPivotKeys = (tabs: ITaskPivotTabs): string[] => {
  const keys: string[] = [];
  if (tabs.taskDetails) keys.push('TaskDetails');
  if (tabs.taskType) keys.push('TaskType');
  if (tabs.checklist) keys.push('Checklist');
  if (tabs.context) keys.push('Context');
  if (tabs.resources) keys.push('Resources');
  if (tabs.activities) keys.push('Activities');
  if (tabs.instances) keys.push('Instances');
  if (tabs.audit) keys.push('Audit');

  return keys;
};
